// SSA Vantage — Global Template Policy Preview
// Uses shared StructuredPolicyRenderer for consistent rendering across all tiers.

import StructuredPolicyRenderer from '../../../shared/components/StructuredPolicyRenderer'

function GlobalTemplatePolicyPreview({ template, versionHistory, onClose, onDownloadDocx, onDownloadPdf }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-4xl max-h-[95vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-3 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl flex-shrink-0">
          <div className="min-w-0">
            <h2 className="text-base font-semibold text-gray-900 dark:text-white truncate max-w-lg">{template.title}</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {template.domain}
              {template.version_number && ` \u00B7 v${template.version_number}`}
            </p>
          </div>
          <div className="flex items-center gap-2 ml-4 flex-shrink-0">
            <button onClick={onDownloadDocx} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
              <svg className="w-3.5 h-3.5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
              .docx
            </button>
            <button onClick={onDownloadPdf} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
              <svg className="w-3.5 h-3.5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
              .pdf
            </button>
            <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>
        </div>

        {/* Document preview */}
        <div className="flex-1 overflow-y-auto p-6" style={{ backgroundColor: '#F1F5F9' }} id="global-template-preview-content">
          <div className="max-w-[750px] mx-auto bg-white shadow-lg" style={{ minHeight: '1000px' }}>
            <StructuredPolicyRenderer structuredContent={template.structured_content} template={template} versionHistory={versionHistory} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default GlobalTemplatePolicyPreview
